// extracted by mini-css-extract-plugin
module.exports = {"container":"Share_container__2D2hQ","inner":"Share_inner__2LZB5","icon":"Share_icon__2K64Z","drawing":"Share_drawing___Qn11","no_text":"Share_no_text__1dtTM"};